<template>
    <properties-block v-bind="$props" v-on="$listeners">
<!--        <template #layout>-->
<!--            <b-form-group label-cols="4">-->
<!--                <template #label>-->
<!--                    <span v-tr>Column Span|Largeur de la colonne</span>-->
<!--                    <btn-responsive-prop v-model="block" field="span"/>-->
<!--                </template>-->
<!--                <b-select v-model.number="block.mediaProxy.span">-->
<!--                    <option v-for="n in 10" :key="`columns-${n}`" :value="`${n}`">{{n}} span</option>-->
<!--                </b-select>-->
<!--            </b-form-group>-->
<!--        </template>-->

        <properties-component-image title="Image" :value="block.image" :block="block"/>
        <properties-component-glyph title="Icon|Icône" :value="block.glyph" :block="block"/>
        <properties-component-text title="Text|Texte" :value="block.text" :block="block"/>
    </properties-block>
</template>

<script>
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";
import PropertiesComponentText from "@components/editor/properties/components/properties-component-text.vue";
import PropertiesComponentImage from "@components/editor/properties/components/properties-component-image.vue";
import PropertiesComponentGlyph from "@components/editor/properties/components/properties-component-glyph.vue";

export default {
    name: `properties-block-table-cell`,
    components: {PropertiesComponentGlyph, PropertiesComponentImage, PropertiesComponentText, PropertiesBlock},
    extends: PropertiesBlock
}
</script>

<style lang="scss" scoped>
</style>
